/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Library_Sortarialabel2Inputs */

const id_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Urutkan pustaka`)
};

const ms_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Susun perpustakaan`)
};

const da_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter bibliotek`)
};

const de_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliothek sortieren`)
};

const en_us2_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sort library`)
};

const es_es2_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar biblioteca`)
};

const es_mx2_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar biblioteca`)
};

const fil_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pagbukud-bukurin ang library`)
};

const fr_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trier la bibliothèque`)
};

const it_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordina libreria`)
};

const hu_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Könyvtár rendezése`)
};

const nl_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bibliotheek sorteren`)
};

const no_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sorter bibliotek`)
};

const pl_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortuj bibliotekę`)
};

const pt_br2_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Classificar biblioteca`)
};

const pt_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ordenar biblioteca`)
};

const ro_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortează biblioteca`)
};

const fi_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Järjestä kirjasto`)
};

const sv_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sortera bibliotek`)
};

const vi_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sắp xếp thư viện`)
};

const tr_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kütüphaneyi sırala`)
};

const cs_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seřadit knihovnu`)
};

const bg_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортиране на библиотеката`)
};

const ru_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортировать библиотеку`)
};

const uk_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Сортувати бібліотеку`)
};

const ar_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ترتيب المكتبة`)
};

const hi_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लाइब्रेरी क्रमबद्ध करें`)
};

const th_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จัดเรียงคลังเกม`)
};

const ja_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ライブラリを並び替え`)
};

const zh_cn2_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序游戏库`)
};

const zh_hant1_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`排序遊戲庫`)
};

const ko_profile_library_sortarialabel2 = /** @type {(inputs: Profile_Library_Sortarialabel2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`라이브러리 정렬`)
};

/**
* | output |
* | --- |
* | "Sort library" |
*
* @param {Profile_Library_Sortarialabel2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const profile_library_sortarialabel2 = /** @type {((inputs?: Profile_Library_Sortarialabel2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Library_Sortarialabel2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_profile_library_sortarialabel2(inputs)
	if (locale === "ms") return ms_profile_library_sortarialabel2(inputs)
	if (locale === "da") return da_profile_library_sortarialabel2(inputs)
	if (locale === "de") return de_profile_library_sortarialabel2(inputs)
	if (locale === "en-US") return en_us2_profile_library_sortarialabel2(inputs)
	if (locale === "es-ES") return es_es2_profile_library_sortarialabel2(inputs)
	if (locale === "es-MX") return es_mx2_profile_library_sortarialabel2(inputs)
	if (locale === "fil") return fil_profile_library_sortarialabel2(inputs)
	if (locale === "fr") return fr_profile_library_sortarialabel2(inputs)
	if (locale === "it") return it_profile_library_sortarialabel2(inputs)
	if (locale === "hu") return hu_profile_library_sortarialabel2(inputs)
	if (locale === "nl") return nl_profile_library_sortarialabel2(inputs)
	if (locale === "no") return no_profile_library_sortarialabel2(inputs)
	if (locale === "pl") return pl_profile_library_sortarialabel2(inputs)
	if (locale === "pt-BR") return pt_br2_profile_library_sortarialabel2(inputs)
	if (locale === "pt") return pt_profile_library_sortarialabel2(inputs)
	if (locale === "ro") return ro_profile_library_sortarialabel2(inputs)
	if (locale === "fi") return fi_profile_library_sortarialabel2(inputs)
	if (locale === "sv") return sv_profile_library_sortarialabel2(inputs)
	if (locale === "vi") return vi_profile_library_sortarialabel2(inputs)
	if (locale === "tr") return tr_profile_library_sortarialabel2(inputs)
	if (locale === "cs") return cs_profile_library_sortarialabel2(inputs)
	if (locale === "bg") return bg_profile_library_sortarialabel2(inputs)
	if (locale === "ru") return ru_profile_library_sortarialabel2(inputs)
	if (locale === "uk") return uk_profile_library_sortarialabel2(inputs)
	if (locale === "ar") return ar_profile_library_sortarialabel2(inputs)
	if (locale === "hi") return hi_profile_library_sortarialabel2(inputs)
	if (locale === "th") return th_profile_library_sortarialabel2(inputs)
	if (locale === "ja") return ja_profile_library_sortarialabel2(inputs)
	if (locale === "zh-CN") return zh_cn2_profile_library_sortarialabel2(inputs)
	if (locale === "zh-Hant") return zh_hant1_profile_library_sortarialabel2(inputs)
	return ko_profile_library_sortarialabel2(inputs)
});
export { profile_library_sortarialabel2 as "profile.library.sortAriaLabel" }